import {Injectable, HostListener} from '@angular/core';

import {LogService} from './log.service';


@Injectable()
export class DragDropService {
	constructor (
		private log: LogService
	) {}


	isDragging = false;
	isCopying = false;
	draggingElement = null;
	data = {};



	// http://stackoverflow.com/a/37400131
	// @HostListener('document:mouseup', ['$event'])
	// onDragEnd(event: any) {
	// 	console.log('DragDropService mouseup');

	// 	this.endDrag();
	// }


	endDrag() {
		console.log('DragDropService endDrag');

		window.document.body.classList.remove('dragging');
		window.document.body.classList.remove('dragging-copy');
		window.document.body.classList.remove('dragging-move');

		if (this.draggingElement) {
			this.draggingElement.classList.remove('drag-source');
		}

		this.isDragging = false;
		this.draggingElement = null;
	}


	escapeKeyPressed() {
		if (this.isDragging) {
			console.log('cancelling drag!!');
			this.endDrag();
		}
	}


	copyKeyPressed() {
		if (this.isDragging) {
			console.log('switch to copy!!');

			this.isCopying = true;
			window.document.body.classList.remove('dragging-move');
			window.document.body.classList.add('dragging-copy');
		}
	}


	copyKeyReleased() {
		if (this.isDragging) {
			console.log('switch to move!!');

			this.isCopying = false;
			window.document.body.classList.remove('dragging-copy');
			window.document.body.classList.add('dragging-move');
		}
	}

}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/drag-drop.service.ts